import { FC } from 'react';
import { Text } from '../components/Typography';

type SmallButtonOwnProps = {
  leftIcon?: React.ReactNode;
  title: string;
  rightIcon1?: React.ReactNode;
  rightIcon2?: React.ReactNode;
};

export type SmallButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> &
  SmallButtonOwnProps;

export const SmallButton: FC<SmallButtonProps> = ({
  leftIcon,
  title,
  rightIcon1,
  rightIcon2,
  ...props
}) => {
  return (
    <button
      className="flex flex-row items-center rounded-[16px] w-fit h-[32px] px-4 gap-2 cursor-pointer bg-peach dark:bg-grey-light-dark text-grey-black dark:text-grey-main-dark hover:bg-peach-1 hover:dark:bg-grey-plain-dark"
      {...props}
    >
      {leftIcon}
      <Text variant="text-md-regular">{title}</Text>
      {rightIcon1}
      {rightIcon2}
    </button>
  );
};
